<template>
	<div class="ui-stat" :class="[ type, 'size-' + size ]">
		<!-- <div class="icon bg" v-bg="type + '.png'"></div> -->
		<div v-if="illustration" class="icon" v-bg="illustration"></div>
		<div v-else class="no-icon"></div>
		<div class="value">{{ value }}</div>
	</div>
</template>

<script>
export default {
	name: 'ui-stat',
	props: {
		value: { default: 0 },
		type: { default: null },
		size: { default: 56 }
	},
	computed: {
		illustration() {
			const types = [ 'armor', 'life', 'gold', 'attack', 'poison', 'weakness', 'strength' ]
			if (types.includes(this.type)) return 'ui/' + this.type + '.png'
			return null
		}
	}
}
</script>

<style lang="stylus" scoped>

.ui-stat
	display inline-block
	width 64px
	height 64px
	flex center center
	font-size 4rem
	&.size-80
		font-size 6.4rem
		width 104px
		height 104px
	&.life
		padding-bottom 4px
	&.armor
		padding-bottom 8px
	&.attack
		transform scale(1.1)
	&.poison, &.weakness, &.strength
		color dark
		// background-color #E0BB86
		// border-radius 50%
		// box-shadow 0 0 8px alpha(#000, 25%)
		.value
			absolute 25%
			transform translate(60%, 60%)
			background-color #fff
			border-radius 50%
			box-shadow 0 0 8px alpha(#000, 25%)
			c = #fff
			text-shadow -1px -1px c, -1px 1px c, 1px -1px c, 1px 1px c
		.icon
			absolute 0px
	&.poison .icon
		transform scaleX(-1)
	.icon
		absolute 0
		background center center no-repeat
		background-size contain
	.no-icon
		absolute 4px
		background red
		border-radius 50%
			

</style>
